import React from 'react';
import { Card } from 'primereact/card';
import moment from 'moment';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { isCurrentDatePastExpiry } from 'utils/utility_functions/isCurrentDatePastExpiry';

const FileSharingDetailsCard = ({ rowData }) => {
  const userContext = useUserDetailsContext();

  const expiryDate = rowData?.lawft_link_expires_on;
  const isExpired = isCurrentDatePastExpiry(expiryDate, userContext?.userDetails?.timezone);
  const formattedExpiry = expiryDate ? moment.utc(expiryDate).format('MMM DD, YYYY') : null;

  return (
    <div className="file-sharing-details">
      <div className="shared-card-container">
        <Card className="shared-card card-bg">
          {expiryDate && (
            <div className="grey-section pointer">
              <div className="text-bold black-600 mb-2">Shared via Lawft Link</div>

              <div className="downloads-views-section">
                <div className="info">
                  <div className="p-column-title">Downloads</div>
                  <div className="value">{rowData?.download_count ? rowData?.download_count : 0}</div>
                </div>
                <div className="info">
                  <div className="p-column-title">Views</div>
                  <div className="value">{rowData?.view_count ? rowData?.view_count : 0}</div>
                </div>
              </div>

              {formattedExpiry && (
                <div className="mt-2 F-size12">
                  <span className={isExpired ? 'text-expire' : 'black-600'}>
                    {isExpired ? 'Expired on' : 'Expires on'} <span className="text-bold">{formattedExpiry}</span>
                  </span>
                </div>
              )}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default FileSharingDetailsCard;
